export default __webpack_public_path__ + "static/media/kiwisupercocktail.056074f1.jpg";